import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "email",
  "use": "email-usage",
  "viewBox": "0 0 62.9 46.3",
  "content": "<symbol viewBox=\"0 0 62.9 46.3\" id=\"email\">\n<g>\n\t<path class=\"st0\" d=\"M55.9,0H7C3.1,0,0,3.1,0,7v32.3c0,3.8,3.1,7,7,7h49c3.8,0,7-3.1,7-7V7C62.9,3.1,59.7,0,55.9,0L55.9,0z\n\t\t M58.7,39.3c0,1.5-1.3,2.8-2.8,2.8H7c-1.5,0-2.8-1.3-2.8-2.8V7c0-1.5,1.3-2.8,2.8-2.8h49c1.5,0,2.8,1.3,2.8,2.8V39.3z\" />\n\t<path class=\"st0\" d=\"M52.3,11.1L31.4,24.2L10.6,11.1c-1-0.6-2.3-0.3-2.9,0.7c-0.6,1-0.3,2.3,0.7,2.9l21.9,13.8\n\t\tc0.3,0.2,0.7,0.3,1.1,0.3h0.1c0.4,0,0.8-0.1,1.1-0.3l21.9-13.8c1-0.6,1.3-1.9,0.7-2.9C54.5,10.7,53.2,10.4,52.3,11.1L52.3,11.1z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/email.svg
// module id = i1m2
// module chunks = 264